const Appcolors = {
    title: '#202124',
    backgroundColor: '#f0f2f5',
    textFiled: '#3a4c6b',
    textFiledDisabled: '#00000099',
    backgroundDisabled: '#0000000f',
    success: '',
    error: '',
    warn: '',
    default: '',
};

export default Appcolors;
